<template>
	<div v-if="rules.length > 0">
		<div v-for="itemData in rules" class="link">
			<el-link :href="itemData.href" target="_blank" type="primary">{{ itemData.name }}</el-link>
			<br />
		</div>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import {isAnZe15, isAnZeProduct, isMeiYaB, isMeiYaC} from '@/util/productUtil'

export default {
	name: 'rules',
	mixins: [],
	components: {},
	props: {
		insureType: {
			required: true,
		},
		productId: {
			required: true,
		},
	},
	data() {
		return {
			rules: [],
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
	},
	watch: {
		insureType: {
			handler(newVal, oldVal) {
				if (!this.validatenull(newVal) && this.productId) {
					this.initRules()
				}
			},
			immediate: true,
		},
	},
	created() {},
	mounted() {},
	methods: {
		initRules() {
			let tempTitle = ''
			//把title发送出去
			this.$emit('onSendTitle', tempTitle)
		},
	},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
.link {
	margin-bottom: 4px;
}
</style>
